import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ApiError } from '@/api/client';
import { Icon } from '@/components/Icon';
import { Spinner } from '@/components/primitives/Spinner';
import { apiErrorText } from '@/api/opengater/errors';
import s from './UserActions.module.css';
export function ActionGroup({ title, children }) {
    return (_jsxs("section", { className: s.group, children: [title ? _jsx("h3", { className: s.groupTitle, children: title }) : null, _jsx("div", { className: s.island, children: children })] }));
}
export function ActionRow({ icon, tone = 'neutral', label, description, children, }) {
    return (_jsxs("div", { className: s.row, children: [icon ? (_jsx("span", { className: s.glyph, "data-tone": tone, children: _jsx(Icon, { name: icon, size: 15 }) })) : null, _jsxs("div", { className: s.rowText, children: [_jsx("div", { className: s.rowLabel, children: label }), description ? _jsx("div", { className: s.rowDescription, children: description }) : null] }), children !== undefined ? _jsx("div", { className: s.rowValue, children: children }) : null] }));
}
export function ActionLoading({ label = 'Загрузка…' }) {
    return (_jsxs("div", { className: s.loading, children: [_jsx(Spinner, { size: 14 }), " ", label] }));
}
export function ActionNotice({ children, tone = 'neutral', }) {
    return (_jsx("div", { className: s.notice, "data-tone": tone, children: children }));
}
export function isMissingActionRoute(error) {
    if (!(error instanceof ApiError) || error.status !== 404)
        return false;
    const detail = error.body?.detail;
    return detail === 'Not Found';
}
export function ActionUnavailable({ children }) {
    return (_jsxs("div", { className: s.unavailable, role: "status", children: [_jsx("span", { className: s.unavailableIcon, "aria-hidden": "true", children: _jsx(Icon, { name: "info", size: 15 }) }), _jsxs("div", { children: [_jsx("strong", { children: children }), _jsx("span", { children: "\u0421\u0435\u0440\u0432\u0435\u0440 \u044D\u0442\u043E\u0433\u043E \u0441\u0442\u0435\u043D\u0434\u0430 \u0435\u0449\u0451 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u0444\u0443\u043D\u043A\u0446\u0438\u044E." })] })] }));
}
export function ActionError({ error, fallback }) {
    if (isMissingActionRoute(error)) {
        return _jsx(ActionUnavailable, { children: "\u0424\u0443\u043D\u043A\u0446\u0438\u044F \u043F\u043E\u043A\u0430 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u043D\u0430 \u044D\u0442\u043E\u043C \u0441\u0442\u0435\u043D\u0434\u0435." });
    }
    return _jsx(ActionNotice, { tone: "danger", children: apiErrorText(error, fallback) });
}
export function PremiumBadge() {
    return (_jsxs("span", { className: s.premium, children: [_jsx(Icon, { name: "crown", size: 11 }), " PREMIUM"] }));
}
